export function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 lg:py-12">
      {/* Hero */}
      <div className="text-center mb-12">
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-indigo-400 to-indigo-600 flex items-center justify-center mx-auto mb-6 shadow-lg shadow-indigo-200">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>
          </svg>
        </div>
        <h1 className="text-3xl lg:text-4xl font-serif font-bold text-slate-900 tracking-tight mb-3">
          About EventsCarousel
        </h1>
        <p className="text-lg text-slate-500 max-w-xl mx-auto leading-relaxed">
          A family archive, built to last generations.
        </p>
      </div>

      {/* Main prose */}
      <div className="space-y-8 text-slate-700">

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2.5">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </span>
            Your story, in your own voice
          </h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Each person is the curator of their own life — they know their own experiences, their successes, their failures, their moments of joy and their moments of sorrow. Each of these are precious memories. EventsCarousel lets you and your friends and family collaborate to record, experience, and re-experience your family history.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg bg-amber-50 flex items-center justify-center flex-shrink-0">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2.5">
                <path d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2z"/>
                <path d="M12 8v4l3 3"/>
              </svg>
            </span>
            Before the voices are lost
          </h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            How we long to hear again the voice of our grandfather telling his story of immigration, or the story of how he met his wife, or the stories of his struggles as a child. In today's world of smart phones, smart devices, and smart gadgets, too many of our precious life events and voices are lost forever. The more technology we have, the less we communicate.
          </p>
        </section>

        <section className="bg-indigo-600 rounded-2xl p-6 lg:p-8 shadow-lg shadow-indigo-200 text-white">
          <h2 className="text-lg font-bold mb-3 flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
              </svg>
            </span>
            The slide projector moment
          </h2>
          <p className="text-sm lg:text-base leading-relaxed text-indigo-100">
            EventsCarousel brings back the experience of families and friends getting together to view shared experiences and recall precious memories. To retell family stories and laugh, all over again. At the center of those events was a simple carousel slide projector, loaded with slides that Mom or Dad had developed after the family camping trip. Or after your cousin's wedding. Those stories are what make families and friends special to each other.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center flex-shrink-0">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
            </span>
            A sense of belonging
          </h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Personal and family narratives give members of a family a sense of belonging, in a time when such experiences are quickly fading from memory. EventsCarousel is a family archive — a collection of family history. As such, it will be passed from generation to generation so that family history is not lost.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2.5">
                <rect x="3" y="3" width="18" height="18" rx="2"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
              </svg>
            </span>
            Each event is a slide
          </h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            Just as each slide in the carousel was an event, so too in the EventsCarousel application, each picture loaded is considered an event. An event can be as simple as a picture of a friend or child, or as complex as a wedding or high school graduation — with photos, recorded voices, and stories that bring it to life.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-indigo-50">
          <h2 className="text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg bg-rose-50 flex items-center justify-center flex-shrink-0">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f43f5e" strokeWidth="2.5">
                <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
              </svg>
            </span>
            A story, set to music
          </h2>
          <p className="text-sm lg:text-base leading-relaxed text-slate-600">
            A Milestone Slideshow follows one person's whole story — every photo they appear in, from the very first to the most recent, drawn automatically from across your archive and playable any time. Share a link and the people who love them can add their own photos to fill in the gaps, each one reviewed before it joins the family record. And because a slide show was always as much about the room as the pictures on the wall, every slideshow can now play with a quiet musical accompaniment underneath — softening automatically whenever someone's own voice takes over to tell the story themselves. (Background music courtesy of Erik Satie, Johann Pachelbel, and Kevin MacLeod's public-domain performances.)
          </p>
        </section>

      </div>
    </div>
  );
}
